import React from 'react';
import { Navigate } from 'react-router-dom';

// Old registration links return to sign-in; accounts are issued by management.
export default function Register() {
  return <Navigate to="/login" replace />;
}
